export default __webpack_public_path__ + "static/img-kortical-timeline--mobile-cc05e5ddf1fb1c541714f3fd15139812.webp";